import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const details = [{
  label: "Address",
  value: "12400 W Olympic Blvd, Los Angeles, CA"
}, {
  label: "Landmark",
  value: "Across from the 405 off-ramp"
}, {
  label: "Hours",
  value: "Mon-Sat: 8AM - 6PM"
}, {
  label: "Service Area",
  value: "Greater Los Angeles"
}, {
  label: "Response Time",
  value: "Same-Day Service"
}, {
  label: "Contact",
  value: "(310) 555-0199"
}];
export default function PracticalDetails() {
  return <section data-section-id="236055" id="visit-us-today" className="bg-background text-foreground py-24 md:py-32">
      <div className="container mx-auto px-6 max-w-4xl">
        <div className="mb-16 text-center">
          <h2 className="text-3xl md:text-5xl font-default font-black text-foreground tracking-tighter italic uppercase">
            Visit Us Today
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-8 mb-24">
          {details.map((item, i) => <div key={i} data-index={i} className="flex flex-col border-b border-primary/30 pb-4 group hover:border-primary transition-colors duration-300">
              <span className="text-xs font-mono text-primary uppercase tracking-widest mb-2">
                {item.label}
              </span>
              <span className="text-xl font-default font-bold text-foreground group-hover:text-primary transition-colors duration-300">
                {item.value}
              </span>
            </div>)}
        </div>

        <div className="flex justify-center">
          <Button asChild variant="outline" size="lg" className="rounded-sm border-2 border-primary text-primary-foreground bg-primary hover:bg-primary/90 hover:shadow-[0_0_20px_rgba(249,115,22,0.4)] transition-all duration-300 h-auto py-4 px-10 text-lg font-default font-black italic uppercase tracking-tight">
            <Link to="tel:+14243138474">Call Now</Link>
          </Button>
        </div>
      </div>
    </section>;
}